<ng-template #formpolicy let-c="close" let-d="dismiss">
  @if(policy) {
  <app-form-policy (editP)="editPolicy($event)" [policy]='policy' [create]="false"
    (closeEvent)="modaldismiss($event)"></app-form-policy>
  }
</ng-template>

<ng-template #simulate let-c="close" let-d="dismiss">
  <app-form-add-policy-and-simulation [addpolicy]="false" [policy]="policy"
    (action)="modaldismiss($event)"></app-form-add-policy-and-simulation>
</ng-template>

<ng-template #duplicate let-c="close" let-d="dismiss">
  <div class="modal-body duplicate-modal">
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex flex-row head align-items-center justify-content-center">
        <h2>{{'security-policies-form-duplicate-title' | translate}} {{policy?.name}}?</h2>
        <img type='button' placement="top" ngbTooltip="{{'security-policies-form-duplicate-tooltip' | translate}}"
          [closeDelay]="50000" src="assets/icons/info.svg">
      </div>
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary" (click)="c('Cross click')">{{'cancel' |
          translate}}</button>
        <button type="button" class="btn btn-outline-success" (click)="emitDuplicate();c('Save changes')">{{'confirm' |
          translate}}</button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #delete let-c="close" let-d="dismiss">
  <div class="modal-body delete-modal">
    <div class="d-flex flex-column align-items-center">
      <h2>{{'security-policies-form-delete-title' | translate}} {{policy?.name}}?</h2>
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary" (click)="c('Cross click')">{{'cancel' |
          translate}}</button>
        <button type="button" class="btn btn-outline-success" (click)="emitDelete(); c('Save changes')">{{'confirm' |
          translate}}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #refuse let-c="close" let-d="dismiss">
  <app-confirmation-form [type]="'refuse'" [policy]="policy" (closeEvent)="modaldismiss($event)"
    (action)="sendAction($event)"></app-confirmation-form>
</ng-template>

<ng-template #accept let-c="close" let-d="dismiss">
  <app-confirmation-form [type]="'accept'" [policy]="policy" (closeEvent)="modaldismiss($event)"
    (action)="sendAction($event)"></app-confirmation-form>
</ng-template>

<ng-template #submit let-c="close" let-d="dismiss">
  <app-confirmation-form [type]="'submit'" [policy]="policy" (closeEvent)="modaldismiss($event)"
    (eventSubmit)="submitEvent($event)"></app-confirmation-form>
</ng-template>

<div #details>
  @if (policy) {
  <div>
    <div>
      <div class="header">
        <div class="d-flex flex-row justify-content-between align-items-center head">
          @if (!isAdmin() || (isAdmin() && !checkStatus())) {
          <h1 class="edit-policy-name">{{ policy.name }}</h1>
          } @else {
          <div class="d-flex flex-row justify-content-around align-items-center nameform">
            <h1 class="edit-policy-name">
              <input class="form-control" [formControl]="editform">
              @if (editform.invalid && editform.dirty) {
              <div class="alert alert-head alert-danger">
                @if (editform.errors?.['required']) {
                <div>
                  {{ 'setting-form-error-required' | translate }}
                </div>
                }
                @if (editform.errors?.['exist']) {
                <div>
                  {{ 'setting-form-error-already-exist' | translate }}
                </div>
                }
                @if (editform.errors?.['whitespace'] && !editform.errors?.['required']) {
                <div>
                  {{ 'setting-form-error-invalid-value' | translate }}
                </div>
                }
              </div>
              }
            </h1>
            <button class="save" type="button" aria-label="Save"
              [disabled]="editform.invalid || editform.value == policy.name" (click)="changeName()"></button>
          </div>
          }
          <div class="d-flex justify-content-center align-items-center">
            @if (type == 'active') {
            <div class="d-flex flex-row buttons">
              @if (isAdmin() && policy.status == 'SUBMITTED') {
              <button style="margin-right: 1.5vw;"
                class="btn btn-outline-danger d-flex flex-row align-items-center cross" [disabled]="formCheck()"
                (click)="openCenteredVertically(refuse)">
                <img src="assets/icons/Policies/cross.svg">{{'security-policies-details-button-refuse' | translate}}
              </button>
              <button style="margin-right: 1.5vw;"
                class="btn btn-outline-success d-flex flex-row align-items-center accept" [disabled]="formCheck()"
                (click)="openCenteredVertically(accept)">
                <img src="assets/icons/Policies/checkmark.svg">{{'security-policies-details-button-accept' | translate}}
              </button>
              }
              @if (isAdmin() && policy.status == 'REFUSED') {
              <button style="margin-right: 1.5vw;" id="delete" [disabled]="formCheck()"
                class="btn btn-outline-danger d-flex flex-row align-items-center cross delete"
                (click)="openCenteredVertically(delete)">
                <img src="assets/icons/Policies/cross.svg">{{'security-policies-details-button-delete' | translate}}
              </button>
              }
              <button class="btn btn-outline-primary duplicate d-flex flex-row align-items-center cross"
                [disabled]="formCheck()" (click)="openCenteredVertically(duplicate)">
                <img src="assets/icons/Policies/duplicate.svg">{{'security-policies-details-button-duplicate' |
                translate}}
              </button>
            </div>
            } @else if (type == 'simulation') {
            <div class="d-flex flex-row justify-content-around align-items-center">
              <div class="d-flex flex-column buttons">
                <app-form-add-policy-and-simulation [policy]="policy"
                  [disabledB]="formCheck()"></app-form-add-policy-and-simulation>
                <button class="btn btn-outline-primary d-flex flex-row align-items-center edit" [disabled]="formCheck()"
                  (click)="openFullScreen(formpolicy)">
                  <img src="assets/icons/Policies/edit.svg">{{'security-policies-details-button-edit' | translate}}
                </button>
              </div>
              <div class="d-flex flex-column buttons">
                <button *kaHasRoles="['bo-dip-security-policies-submit']; checkRealm:true " id="submit"
                  class="btn btn-outline-success" [disabled]="formCheck()" (click)="openCenteredVertically(submit)">
                  {{'security-policies-details-button-submit' | translate}}
                </button>
                <button class="btn btn-outline-danger d-flex flex-row align-items-center cross delete"
                  [disabled]="formCheck()" (click)="openCenteredVertically(delete)">
                  <img src="assets/icons/Policies/cross.svg">{{'security-policies-details-button-delete' | translate}}
                </button>
              </div>
            </div>
            }
          </div>
        </div>
        <div class="fbuttons d-flex flex-wrap justify-content-around">
          @for (fam of familyDetectors(); track fam) {
          <button class="btn btn-outline-primary" (click)="acc.toggle(fam.toLowerCase()); scroolTo(fam.toLowerCase())">
            {{ fam }}
          </button>
          }
        </div>
        <hr class="headhr">
      </div>
      <div class="scroll">
        <div ngbAccordion #acc="ngbAccordion">
          @for (fam of familyDetectors(); track fam) {
          <div ngbAccordionItem="{{ fam.toLowerCase() }}">
            <div ngbAccordionHeader>
              <button ngbAccordionButton class="accordion-button">
                <div class="d-flex title justify-content-between align-items-center">
                  <h2>{{ fam }}</h2>
                  <div class="tags d-flex flex-row justify-content-around">
                    <div class="tag d-flex flex-row justify-content-center">
                      <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                      <h3 class="value">{{ getTotalLength(fam) }}</h3>
                    </div>
                    <div class="tag d-flex flex-row justify-content-center">
                      <h3 class="name fatal">{{ 'security-policies-details-fatal' | translate }}</h3>
                      <h3 class="value">{{ getFatalLength(fam) }}</h3>
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <div ngbAccordionCollapse>
              <table ngbAccordionBody class="table">
                <thead>
                  <tr>
                    <th scope="col">{{ 'security-policies-details-tab-detector' | translate }}</th>
                    <th scope="col" class="text-center">
                      {{ 'security-policies-details-tab-activation' | translate }}
                    </th>
                    <th scope="col" class="text-center">
                      {{ 'security-policies-details-tab-status' | translate }}
                    </th>
                    <th scope="col" class="text-end">
                      {{ 'security-policies-details-on-demand' | translate }}/{{ 'security-policies-details-periodic' |
                      translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (detector of getAllDetectorOfFam(fam); track detector.id) {
                  @if (detector && detector.name) {
                  <tr>
                    <td>
                      <div class="d-flex justify-content-begin">{{ detector.name }}</div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <img src="assets/icons/Policies/checkmark.svg" class="{{ statutactive(detector) }}">
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        {{ formatStatus(detector).toUpperCase() }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-end">{{ formatPId(detector) }}</div>
                    </td>
                  </tr>
                  }
                  }
                </tbody>
              </table>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>
<app-toast-component></app-toast-component>